




































import axios from 'axios';
import { User } from '../../models/user';

import { Component, Prop, Vue } from 'vue-property-decorator';

import { userWebservice } from '../../webservices/user';

@Component
export default class Login extends Vue {

    protected user: User = {
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        password_confirmation: '',
        phone_number: '',
    };

    protected disabled: boolean = false;
    protected errorMsg: string = '';

    private login() {
        if (this.user.email === '' || this.user.password === '') {
            this.errorMsg = 'Die Emailadresse oder das Passwort fehlt.';
            return;
        }

        userWebservice.login(this.user.email, this.user.password).then((response) => {
            this.errorMsg = '';
            this.$store.commit('account/setApiToken', response.data.api_token);

            userWebservice.getUserInfo().then((userResponse) => {
                this.$store.commit('account/setCurrentUser', userResponse.data);
            });
        }).catch((error) => {
            this.errorMsg = 'Das Passwort oder der Benutzername sind nicht korrekt';
            console.log(error);
        });
    }
}
